(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    let product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);

    // Set this up to be assigned if a selling plan is selected
    let activeSellingPlan;

    // during dev mode, set 344the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/
    const thumbSwiper = new Swiper(section.querySelector(".productV4ContentMediaThumbs"), {
        spaceBetween: 5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            1000: {
                spaceBetween: 8,
            }
        },
        mousewheel: {
            forceToAxis: true
        }
    });
    const productSwiper = new Swiper(section.querySelector(".productV4ContentMediaGallery"), {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: section.querySelector("#productV4ContentMediaGalleryBullets"),
            clickable: true,
        },
        thumbs: {
            swiper: thumbSwiper,
        },
        navigation: {
            nextEl: section.querySelector(".productV4ContentMediaGalleryNext"),
            prevEl: section.querySelector(".productV4ContentMediaGalleryPrev"),
        },
        loop: true
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });


    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**
     * Auto selected the options for and pre-selected product variant. This will grab the correct
     * option selectors when a variant ID is passed into the URL.
     * This method allows for direct variant sharing through the URL.
     * Only runs once on initial page load. UpdateProduct handles every consecutive change.
     */
    function init() {
        // collect options from inputs
        let options = activeVariant.options;
        //for each group of radios, find all that are checked
        section.querySelectorAll(`.productV4OptionsInput`).forEach(group => {
            if (options.includes(group.value)) {
                group.checked = true;
            } else {
                group.checked = false;
            }
        });
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        if (section.querySelector(".productV4BOrder").classList.contains("active")) {
            return !!section.querySelector(`.productV4BOrderLabelInput[value="sub"]:checked`)
        }
        return !!section.querySelector(`.productV4OrderLabelInput[value="sub"]:checked`);
    }

    async function updateProduct() {

        //const orderV4BExists = section.querySelector(".productV4BOrder").classList.contains("active") ?? false;

        //Update the current product from the blocks
        section.querySelectorAll(".productV4VariantsItemInput").forEach(function (element) {
            if (element.checked) {
                product = JSON.parse(element.value);
            }
        });

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            //for each group of radios, find all that are checked
            section.querySelectorAll(`.productV4OptionsInput`).forEach(group => {
                if (group.checked) {
                    options.push(group.value);
                }
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                //look for identical arrays
                return JSON.stringify(variant.options.sort()) === JSON.stringify(options.sort())
            });
        }

// check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV4CartButton").disabled = true;
            section.querySelector(".productV4CartButton").textContent = "Not Available";
            return;
        }

        // Add the variant ID to the url, if the active variant exists
        const url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.pushState(null, "", url.href);

        // reset active selling plan when variant changes
        activeSellingPlan = null;

        //CHECK THE RADIO FOR AN ACTIVE SELLING PlAN
        section.querySelectorAll(".productV4OrderWrapper").forEach(order => {
            const input = order.querySelector(".productV4OrderLabelInput");
            if (input.checked && input.value === "sub") {
                activeSellingPlan = order.querySelector(".productV4OrderDropSelect").value
            }
        });

        section.querySelectorAll(".productV4BOrderItem").forEach(order => {
            const input = order.querySelector(".productV4BOrderLabelInput");
            if (input.checked && input.value === "sub") {
                activeSellingPlan = order.querySelector(".productV4BOrderLabelDropWrapContentLabelSelect").value
            }
        });

        // SCROLL TO THE VARIANT IMAGE
        if (activeVariant.featured_image) {
            // change active slide
            // The variant images are always going to be on slide index 0
            productSwiper.slideTo(0);
            //Update the variants image
            section.querySelectorAll(".variantImage").forEach(image => {
                image.src = activeVariant.featured_image.src;
            })
        }

        // UPDATE THE SCENT TEXT FIELD
        section.querySelectorAll(".productV4OptionsScentItemInput").forEach(option => {
            if (option.checked) {
                section.querySelector(".productV4OptionsScentName").textContent = option.dataset.fragrance;
            }
        });

        // UPDATE THE COLOR TEXT FIELD
        section.querySelectorAll(".productV4OptionsColorItemInput").forEach(option => {
            if (option.checked) {
                section.querySelector(".productV4OptionsColorName").textContent = option.dataset.fragrance;
            }
        });

        // HIDE ALL SWIPERS
        section.querySelectorAll(".productV4ContentMediaGalleryWrapper").forEach(wrapper => {
            wrapper.classList.remove("active");
        });
        // UPDATE THE SWUPER TO SHOW THE CURRENT PRODUCT
        section.querySelectorAll(".productV4ContentMediaGalleryWrapper").forEach(wrapper => {
            if (wrapper.dataset.id === (activeVariant.id).toString()) {
                wrapper.classList.add("active");
            }
        });

        let subDiscount = 1;
        //Calculate the selling plan discount
        section.querySelectorAll(".productV4OrderLabelInput").forEach(radio => {
            if (radio.checked && radio.value === "sub") {
                product.selling_plan_groups.forEach((group) => {
                    group.selling_plans.forEach(plan => {
                        if (plan.id === parseInt(section.querySelector(".productV4OrderDropSelect").value)) {
                            subDiscount = 1.00 - (plan.price_adjustments[0].value / 100);
                        }
                    });
                });
            } else {
                subDiscount = 0.85;
            }
        })

        //Enable the ATC button
        section.querySelector(".productV4CartButton").disabled = false;
        let subPrice = parseInt(activeVariant.price) * subDiscount;
        let otpPrice = parseInt(activeVariant.price);
        let comparePrice;
        if (parseInt(activeVariant.compare_at_price) > otpPrice) {
            comparePrice = parseInt(activeVariant.compare_at_price);
            section.querySelector(".productV4CartButton").innerHTML = `ADD TO CART • ${price(otpPrice)} <span class="productV4CartButtonCompare">${price(comparePrice)}</span>`;
        } else {
            section.querySelector(".productV4CartButton").innerHTML = `ADD TO CART • ${price(otpPrice)}`;
        }

        // Update the price display in ATC button
        //Order buttons variant (new)
        section.querySelector(".productV4BOrderLabelContentPrice.otp").textContent = `${price(otpPrice)}`;
        section.querySelector(".productV4BOrderLabelContentPrice.sub").textContent = `${price(subPrice)}`;
        section.querySelector(".productV4BOrderLabelContentPriceCompare.sub").textContent = `${price(otpPrice)}`;

        //Order Buttons Base
        section.querySelector(".productV4OrderLabelBodyPrice.otp").textContent = ` • ${price(otpPrice)}`;
        section.querySelector(".productV4OrderLabelBodyPrice.sub").textContent = ` • ${price(subPrice)}`;
        section.querySelector(".productV4OrderLabelBodyCompare.sub").textContent = ` • ${price(otpPrice)}`;

        if (isSubscription()) {
            section.querySelector(".productV4CartButton").innerHTML = `ADD TO CART • ${price(subPrice)} <span class="productV4CartButtonCompare">${price(comparePrice)}</span>`;
        } else {
            section.querySelector(".productV4CartButton").innerHTML = `ADD TO CART • ${price(otpPrice)} <span class="productV4CartButtonCompare">${price(comparePrice)}</span>`;
        }


    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    init();
    updateProduct();

    /**************
     Returns button listener
     ***************/
    section.querySelector(".productV4Footnote").addEventListener("click", (e) => {
        section.querySelector(".productV4FootnotePopup").show();
    });
    section.querySelector(".productV4FootnotePopupClose").addEventListener("click", (e) => {
        section.querySelector(".productV4FootnotePopup").close();
    });

    /**************
     Ingredients Button listener
     ***************/
    const ingredientsPopup = section.querySelector(`[id="${product.id}-ingredientsPopupV2"]`) || false
    if (ingredientsPopup) {

        //Animation listner to determine if we animated in or our
        ingredientsPopup.addEventListener("animationend", (e) => {
            if (e.animationName === "popupIn") {
                ingredientsPopup.classList.remove("popupIn");
            } else if (e.animationName === "popupOut") {
                ingredientsPopup.close();
                ingredientsPopup.classList.remove("popupOut");
            }
        });

        //Show the modal
        section.querySelector(".productV3Ingredients").addEventListener("click", (e) => {
            ingredientsPopup.classList.add("popupIn");
            ingredientsPopup.showModal();
        });

        //Hide the modal on close button click
        ingredientsPopup.querySelector(".ingredientsPopupV2Close").addEventListener("click", (e) => {
            ingredientsPopup.classList.add("popupOut");
        });
        //hide the modal if background is clicked
        ingredientsPopup.addEventListener("click", (e) => {
            if (e.target === ingredientsPopup) {
                ingredientsPopup.classList.add("popupOut");
            }
        });
    }

    /**************
     ATC Listener
     ***************/
        // Making the ATC button stick to the bottom of the screen
    let atcParent = section.querySelector(".productV4Cart");
    window.addEventListener("scroll", (e) => {
        if (atcParent.getBoundingClientRect().top <= 0) {
            section.querySelector(".productV4CartButton").classList.add("stick");
        } else {
            section.querySelector(".productV4CartButton").classList.remove("stick");
        }
    })


    /**************
     Product ATC function
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV4CartButton").classList.add("loading");

        let formData = {
            items: [
                {
                    id: activeVariant.id,
                    quantity: 1,
                }
            ]
        };
        if (activeSellingPlan) {
            formData.items[0].selling_plan = activeSellingPlan;
        }

        console.log(formData);

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV4CartButton").classList.remove("loading");

        // open cart
        await openCart();

        //Open the upsell
        //openUpsell(product.id);
    }

    section.querySelector('.productV4CartButton').addEventListener("click", addToCart);
}());